import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const neptuneHighscoresApi = axios.create({
  baseURL: API_BASE_URL + "api/bossbattlehs/neptune",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
